import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { FlatTabs, FlatTab } from '@/components/ui/Tab/FlatTab';
import { professionalRfpOnePath, professionalRfpNegotiatePath, professionalRfpFilePath, } from '@/utils/router/links';
const tabValueDetail = 'detail';
const tabValueNegotiate = 'negotiate';
const tabValueFile = 'file';
/**
 * コンサルタント：案件詳細のタブ
 * @param props
 * @constructor
 */
export const RfpProOneTab = (props) => {
    const { activeValue, className, fileCount, id, isAdmin, isFileShow, isNegotiableShow, isNegotiateDisabled = false, negotiateCount, } = props;
    /** タブの表示内容 */
    const tabs = useMemo(() => {
        const values = [
            // 案件詳細
            {
                count: null,
                labelPc: _jsx(_Fragment, { children: "\u6848\u4EF6\u5185\u5BB9\u3092\u78BA\u8A8D\u3059\u308B" }),
                labelSp: _jsx(_Fragment, { children: "\u6848\u4EF6\u5185\u5BB9" }),
                url: professionalRfpOnePath(`${id}`),
                value: tabValueDetail,
            },
        ];
        // 条件相談
        if (isNegotiableShow) {
            values.push({
                count: !isNegotiateDisabled && negotiateCount > 0 ? negotiateCount : null,
                disabled: isNegotiateDisabled || isAdmin,
                labelPc: _jsx(_Fragment, { children: "\u6761\u4EF6\u306B\u95A2\u3057\u3066\u76F8\u8AC7\u3059\u308B" }),
                labelSp: _jsx(_Fragment, { children: "\u6761\u4EF6\u76F8\u8AC7" }),
                url: professionalRfpNegotiatePath(`${id}`),
                value: tabValueNegotiate,
            });
        }
        // ファイル共有
        if (isFileShow) {
            values.push({
                count: fileCount,
                labelPc: _jsx(_Fragment, { children: "\u8CC7\u6599\u3092\u53D7\u3051\u53D6\u308B" }),
                labelSp: _jsx(_Fragment, { children: "\u8CC7\u6599\u53D7\u53D6" }),
                url: professionalRfpFilePath(`${id}`),
                value: tabValueFile,
            });
        }
        return values;
    }, [
        fileCount,
        id,
        isAdmin,
        isFileShow,
        isNegotiableShow,
        isNegotiateDisabled,
        negotiateCount,
    ]);
    return (_jsx(FlatTabs, Object.assign({ className: className }, { children: tabs.map((tab) => (_jsxs(FlatTab, Object.assign({ activeValue: activeValue, className: clsx('flex justify-center items-center gap-x-8'), disabled: tab.disabled || false, innerPadding: 'sm:p-8', to: tab.url, value: tab.value, widthClassName: 'w-full md:w-[260px]' }, { children: [_jsx("span", Object.assign({ className: clsx('hidden lg:inline') }, { children: tab.labelPc })), _jsx("span", Object.assign({ className: clsx('inline lg:hidden') }, { children: tab.labelSp })), !!tab.count && tab.count > 0 && (_jsx(NumberBadge, { className: clsx('static md:absolute', 'md:right-[30px] md:top-1/2 transform-none md:transform md:-translate-y-1/2'), number: tab.count }))] }), tab.value))) })));
};
export const rfpProOneTabValueDetail = tabValueDetail;
export const rfpProOneTabValueNegotiate = tabValueNegotiate;
export const rfpProOneTabValueFile = tabValueFile;
